// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__qQTgU","hover":"Button_hover__IJg_v","label":"Button_label__YUlJz","link":"Button_link__a_ogG","icon":"Button_icon__V37WX"};